import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { tap, map, switchMap } from 'rxjs/operators';
import { Operation } from 'fast-json-patch';
import { ConfigurationService } from '../../../core/services/ConfigurationService';
import { ConfigurationState } from '../../../core/store/reducers';

import { LoadJobStatusListRequest, LoadJobStatusListResponse, JobStatusResponse } from '../models';

@Injectable()
export class JobStatusService {
  constructor(private http: HttpClient, private configuration: ConfigurationService) {}

  getJobStatusList(request: LoadJobStatusListRequest): Observable<HttpResponse<LoadJobStatusListResponse>> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        return this.http.post<LoadJobStatusListResponse>(`${c.config.apiServer}api/job/status`, request, { observe: 'response' });
      })
    );
  }

  getJobStatus(jobStatusId: number): Observable<JobStatusResponse> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        return this.http.get<JobStatusResponse>(`${c.config.apiServer}api/job/status/${jobStatusId}`);
      })
    );
  }
}
